import ApiService from "../ApiService";
import { AxiosResponse } from "axios";

export const Consents = async (id: any): Promise<AxiosResponse> => {
  ApiService.setHeader();

  const response = await ApiService.query(`consent/${id}`, {});

  response.data.configs.caller = response.data.caller;

  return response;
};

export const BannerConsent = (
  id: any,
  payload: any
): Promise<AxiosResponse> => {
  ApiService.setHeader();
  return ApiService.put(`consent/${id}`, payload);
};

export const ConsentsEvolutionGraph = (
  id: any,
  period: any,
  account: any
): Promise<AxiosResponse> => {
  ApiService.setHeader();
  return ApiService.query(
    `dashboard/${id}/graph/${period}/account/${account}`,
    {}
  );
};

export const ConsentIP = (id: any): Promise<AxiosResponse> => {
  ApiService.setHeader();
  return ApiService.query(`ip/consent/${id}`, {});
};
